// LayoutPage.js
import React, { useState, useEffect } from 'react';
import { 
    Box, TextField, Button, IconButton, Modal,
    Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import LockResetIcon from '@mui/icons-material/LockReset';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Container } from '@mui/material';
import DataTable from 'react-data-table-component';
import { layoutService } from '../../services/layoutService';


const LayoutPage = () => {
    const [layout, setLayout] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterText, setFilterText] = useState('');

    useEffect(() => {
        fetchLayout();
      }, []);
    
    const today = new Date();

    const getStatusText = (idStatus) => {
        return idStatus === 1 ? 'Activo' : 'Inactivo';
    };

    const fetchLayout = async () => {
        try {
          setLoading(true);
          const data = await layoutService.getAllLayout();
          setLayout(data);
          setLoading(false);
        } catch (err) {
          setError('Error al cargar los roles');
          setLoading(false);
        }
      };

    const handleViewDetail = (service) => {
       
    };

    const handleEdit = (roservicele) => {
        
    };

    const handleDelete = (service) => {
        
    };

    const handleAdd = () => {
        
    };
    

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.layoutName,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Servicio',
            selector: row => row.serviceId,
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => getStatusText(row.idStatus),
            sortable: true,
            cell: row => (
            <span className={`apple-badge ${row.idStatus === 1 ? 'apple-badge-success' : 'apple-badge-error'}`}>
                {getStatusText(row.idStatus)}
            </span>
            ),
        },
        {
            name: 'Acciones',
            cell: row => (
            <Box>
                <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
                <VisibilityIcon fontSize="small" />
                <span className="tooltiptext">Ver Detalle</span>
                </IconButton>
                <IconButton onClick={() => handleEdit(row)} size="small" className="apple-button apple-tooltip">
                <EditIcon fontSize="small" />
                <span className="tooltiptext">Editar</span>
                </IconButton>
                <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
                <RemoveCircleOutlineIcon fontSize="small" color='error'/>
                <span className="tooltiptext">Desactivar</span>
                </IconButton>
            </Box>
            ),
            width: '200px',
        },
    ];

    const customStyles = {
        table: {
          style: {
            minWidth: '100%',
          },
        },
        headRow: {
          style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
          },
        },
        headCells: {
          style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
          },
        },
        cells: {
          style: {
            fontSize: '14px',
            color: '#1D1D1F',
          },
        },
    };

    const subHeaderComponentMemo = React.useMemo(() => {
        return (
          <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
            <div className="apple-search-container">
              <SearchIcon className="apple-search-icon" />
              <input
                type="text"
                placeholder="Buscar por nombre"
                onChange={e => setFilterText(e.target.value)}
                className="apple-search-input"
              />
            </div>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAdd}
              className="apple-button"
            >
              Agregar Plantilla
            </Button>
          </Box>
        );
      }, [filterText]);

    return (
        <div className="apple-container">
        <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={layout}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
        </Paper>
        </div>

    );
};

export default LayoutPage;